import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { JobArchitecturePath } from '~/shared/data-contract/job-architecture';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

export const useJobArchitectureItemPath = (
    jobArchitectureId: string,
    itemId: string,
    options: { readonly enabled?: boolean; readonly staleTime?: number } = {},
): UseQueryResult<JobArchitecturePath, Error> => {
    const { getJobArchitectureItemPath } = useApplicationFetchers();

    return useQuery({
        enabled: options.enabled ?? true,
        queryFn: async () => {
            const result = await getJobArchitectureItemPath({ itemId, jobArchitectureId });

            if (result.isOk === true) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: jobArchitectureKeys.itemPath(jobArchitectureId, itemId),
        staleTime: options.staleTime,
        throwOnError: false,
    });
};
